__turbopack_context__.v({
  "card__content": "compare_boat_card-module-scss-module__anrkOW__card__content",
  "card__image": "compare_boat_card-module-scss-module__anrkOW__card__image",
  "card__stats": "compare_boat_card-module-scss-module__anrkOW__card__stats",
  "card__title": "compare_boat_card-module-scss-module__anrkOW__card__title",
  "container": "compare_boat_card-module-scss-module__anrkOW__container",
  "container__card": "compare_boat_card-module-scss-module__anrkOW__container__card",
  "delete__card": "compare_boat_card-module-scss-module__anrkOW__delete__card",
  "delete__text": "compare_boat_card-module-scss-module__anrkOW__delete__text",
  "main__content": "compare_boat_card-module-scss-module__anrkOW__main__content",
  "stats__item": "compare_boat_card-module-scss-module__anrkOW__stats__item",
});
